module.exports = __webpack_public_path__ + "theme/assets/img/d1e88117b6c6b09fefe85bfc25ceacab.png";